var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingStyle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loading Style 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.75C0 8.92157 0.671573 8.25 1.5 8.25C2.32843 8.25 3 8.92157 3 9.75V16.75C3 17.5784 2.32843 18.25 1.5 18.25C0.671573 18.25 0 17.5784 0 16.75V9.75Z",
    fill: "#534AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.75C7 2.92157 7.67157 2.25 8.5 2.25C9.32843 2.25 10 2.92157 10 3.75V22.75C10 23.5784 9.32843 24.25 8.5 24.25C7.67157 24.25 7 23.5784 7 22.75V3.75Z",
    fill: "#9155F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1.75C14 0.921572 14.6716 0.25 15.5 0.25C16.3284 0.25 17 0.921573 17 1.75V24.75C17 25.5784 16.3284 26.25 15.5 26.25C14.6716 26.25 14 25.5784 14 24.75V1.75Z",
    fill: "#534AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.75C21 4.92157 21.6716 4.25 22.5 4.25C23.3284 4.25 24 4.92157 24 5.75V20.75C24 21.5784 23.3284 22.25 22.5 22.25C21.6716 22.25 21 21.5784 21 20.75V5.75Z",
    fill: "#9155F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 8.75C28 7.92157 28.6716 7.25 29.5 7.25C30.3284 7.25 31 7.92157 31 8.75V17.75C31 18.5784 30.3284 19.25 29.5 19.25C28.6716 19.25 28 18.5784 28 17.75V8.75Z",
    fill: "#534AD8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingStyle1);
export default __webpack_public_path__ + "static/media/Loading Style 1.a4fcd3bda15bf704dc8ecf589eb12856.svg";
export { ForwardRef as ReactComponent };